import React, { PropsWithChildren } from 'react';
import { NameValuePair } from '../model/generic.model';

export enum MOTORS_PROP {
    'Make' = 'manufacturer',
    'Model' = 'model',
    'Year' = 'dateVehicleFirstRegistered',
    'Mileage' = 'mileageFromOdometer',
    'Body type' = 'bodyType',
    'Fuel type' = 'fuelType',
    'Transmission' = 'vehicleTransmission',
    'Colour' = 'color',
    'Engine size' = 'vehicleEngine',
}

export enum ADDITIONAL_MOTORS_PROP {
    'vehicle_registration_year' = 'productionDate',
    'vehicle_body_type' = 'bodyType',
    'vehicle_mileage' = 'mileageFromOdometer',
    'vehicle_transmission' = 'vehicleTransmission',
    'vehicle_fuel_type' = 'fuelType',
    'vehicle_urban_mpg' = 'fuelConsumption',
    'vehicle_extra_urban_mpg' = 'fuelConsumption',
    'vehicle_emission' = 'emissionsCO2',
    'vehicle_engine_power' = 'vehicleEngine',
    'vehicle_engine_size' = 'vehicleEngine',
    'vehicle_acceleration_0_62' = 'accelerationTime',
    'vehicle_top_speed' = 'speed',
    'vehicle_seats' = 'vehicleSeatingCapacity',
    'vehicle_colour' = 'color',
    'vehicle_previous_keepers' = 'numberOfPreviousOwners',
}

export interface VHCData {
    checked: boolean;
    extended: boolean;
}

export interface CommonAttribute extends BaseAttribute {
    name: 'Posted' | 'Seller Type';
}

export interface PetsAttribute extends BaseAttribute {
    key:
        | 'dog_breed'
        | 'cat_breed'
        | 'pet_date_of_birth'
        | 'pet_rehome_ready_date'
        | 'deflead'
        | 'microchipped'
        | 'neutered_or_spayed'
        | 'vaccinated'
        | 'viewable_with_mother'
        | 'dog_kc_registered'
        | 'cat_registered'
        | 'pets_health_checked';
}

export const phoneBrandsWithModelChoice = [
    'mobile_model_apple',
    'mobile_model_samsung',
    'mobile_model_huawei',
    'mobile_model_xiaomi',
    'mobile_model_google',
] as const;

export type PhoneBrandsWithModelChoice = typeof phoneBrandsWithModelChoice[number];

export interface PhonesAttribute extends BaseAttribute {
    key:
        | 'mobile_condition'
        | 'mobile_storage_capacity'
        | 'mobile_colour'
        | PhoneBrandsWithModelChoice;
}

export interface DIYAttribute extends BaseAttribute {
    key: 'diy_tools_materials_condition';
}

export interface MotorsAttribute extends BaseAttribute {
    itemProp: MOTORS_PROP;
}
export interface SpecialMotorsAttribute extends BaseAttribute {
    itemProp: ADDITIONAL_MOTORS_PROP;
}
/**
 * See AttributeNameValuePair.java.
 */
export interface BaseAttribute extends NameValuePair {
    key: string;
    unit: string;
    /** Integer-valued. */
    vipOrder: number;
}

export interface BaseAttributeGroup {
    id?: string;
    label: string;
    attributes: BaseAttribute[];
}
export interface SpecialMotorsAttributeGroup extends BaseAttributeGroup {
    attributes: SpecialMotorsAttribute[];
}

export type PropertyAttributes = {
    sellerType: string;
    dateAvailable: string;
    propertyType: string;
    numberOfBedrooms: string;
};

export type JobsAttributes = {
    hours: string;
    recruiter: string;
    salary: string;
};

export type MotorsAttributes = {
    year: string;
    mileage: string;
    fuelType: string;
    engineSize: string;
};

export interface AttributeType {
    [key: string]: object | number | string;
    vehicle_registration_year: number;
    vehicle_mileage: number;
    vehicle_fuel_type: string;
    vehicle_engine_size: number;
}

export interface HomeGardenttributes extends BaseAttribute {
    key: 'common_for_sale_condition' | 'common_for_sale_colour' | 'common_for_sale_material';
}

export interface FashionAttributes extends BaseAttribute {
    key:
        | 'common_for_sale_condition'
        | 'common_for_sale_colour'
        | 'common_for_sale_material'
        | 'fashion_brand'
        | 'common_for_sale_gender'
        | 'kid_age'
        | 'kid_age_optional'
        | 'baby_age'
        | 'male_shoe_size'
        | 'female_shoe_size'
        | 'accessory_size'
        | 'female_clothing_size'
        | 'female_bra_size'
        | 'male_clothing_size'
        | 'male_formal_shirt_size'
        | 'male_suit_size'
        | 'male_suit_waist_size'
        | 'male_coat_size'
        | 'male_tourser_waist_size'
        | 'male_tourser_length'
        | 'male_short_size'
        | 'baby_shoe_size'
        | 'kid_shoe_size';
}

export interface PanelAttributesComponent<T> {
    (props: T): ReturnType<React.FC<PropsWithChildren<T>>>;
    createValidateCallback?: () => () => void;
}
